var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaucetIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1.75V2.21875L3.75 1.75C3.05859 1.75 2.5 2.30859 2.5 3C2.5 3.69141 3.05859 4.25 3.75 4.25L7.5 3.78125L8.71094 3.62891L8.75 3.625L8.78906 3.62891L10 3.78125L13.75 4.25C14.4414 4.25 15 3.69141 15 3C15 2.30859 14.4414 1.75 13.75 1.75L10 2.21875V1.75C10 1.05859 9.44141 0.5 8.75 0.5C8.05859 0.5 7.5 1.05859 7.5 1.75ZM1.25 8C0.558594 8 0 8.55859 0 9.25V11.75C0 12.4414 0.558594 13 1.25 13H5.16016C5.94922 14.1328 7.26562 14.875 8.75 14.875C10.2344 14.875 11.5508 14.1328 12.3398 13H13.75C14.4414 13 15 13.5586 15 14.25C15 14.9414 15.5586 15.5 16.25 15.5H18.75C19.4414 15.5 20 14.9414 20 14.25C20 10.7969 17.2031 8 13.75 8H12.5L11.6172 7.11719C11.3828 6.88281 11.0664 6.75 10.7344 6.75H10V5.03906L8.75 4.88281L7.5 5.03906V6.75H6.76953C6.4375 6.75 6.12109 6.88281 5.88672 7.11719L5 8H1.25Z",
    fill: "#F9F8F9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaucetIcon);
export default __webpack_public_path__ + "static/media/faucet_icon.d8d7930513ede57cdc32eb3f1786aaaf.svg";
export { ForwardRef as ReactComponent };